// Central palette: CHART_COLORS lives in `chartTheme.js`. This file keeps the
// legacy exports (`FALLBACK_COLORS`, `TX_COLORS`, `colorFor`, `heatColor`)
// so downstream imports don't break — they now delegate to the brand palette.
import { CHART_COLORS } from "./chartTheme";

export { CHART_COLORS };

// Alias for backwards compatibility. All callers that used FALLBACK_COLORS
// keep working; new code should import CHART_COLORS from chartTheme.
export const FALLBACK_COLORS = CHART_COLORS;

// Transaction-type accents — remapped to the brand palette so every chart
// that colours by tx-type stays consistent with generic series charts.
export const TX_COLORS = {
  "RF PICK":  CHART_COLORS[0], // azul
  "RF STAGE": CHART_COLORS[1], // naranja
  "RF TRNS":  CHART_COLORS[2], // verde
  "RF RCPT":  CHART_COLORS[3], // rojo
  "RF.RCVR":  CHART_COLORS[4], // amarillo
  "RF LOAD":  CHART_COLORS[5], // púrpura
};

export function colorFor(key, idx = 0) {
  if (TX_COLORS[key]) return TX_COLORS[key];
  return CHART_COLORS[idx % CHART_COLORS.length];
}

// Heatmap palette: monochrome blue-teal escalado por intensidad (0..1).
// Piso: slate-200 (fondo claro, legible con texto oscuro).
// Techo: primary blue (para valores altos, con texto blanco encima).
export function heatColor(intensity) {
  const t = Math.max(0, Math.min(1, intensity));
  // slate-200 (#E2E8F0) → primary (#2563EB)
  const r = Math.round(226 + (37 - 226) * t);
  const g = Math.round(232 + (99 - 232) * t);
  const b = Math.round(240 + (235 - 240) * t);
  return `rgb(${r}, ${g}, ${b})`;
}

/**
 * Contrast text color for a heatmap cell — white when the cell is dark,
 * slate-800 when the cell is light. Threshold matches the mid-point of
 * `heatColor`.
 */
export function heatTextColor(intensity) {
  return intensity > 0.55 ? "#FFFFFF" : "#1E293B";
}
